import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';

const bulletinsStatistiquesData = [
  {
  title: "NewsStat du Mois de la Statistique au Burundi",
  description: "La NewsStat du Mois de la Statistique au Burundi présente les activités marquantes organisées par l'INSBU, visant à promouvoir la visibilité du Système Statistique National (SSN) et à renforcer les capacités. Cette édition trimestrielle, préparée par le Service Publication, Diffusion et Communication, invite les lecteurs à partager leurs observations et suggestions pour améliorer les prochaines publications.",
  link: "/documents/NewsStats/NEWSSTATJAS_FIN.pdf",
  date: "2025-12-30",
  image: 'assets/Bulletins/newsStat.PNG',
},
{
  title: "NewsStat du troisième trimestre 2025",
  description: "La NewsStat du troisième trimestre 2025 (juillet à septembre) présente les activités exceptionnelles de l'INSBU, incluant les ateliers de renforcement des capacités en communication et diffusion des statistiques officielles avec l’appui de la Communauté Est Africaine, la production des comptes nationaux provisoires, ainsi que l’évaluation de la qualité des productions statistiques. Cette édition trimestrielle invite les lecteurs à partager leurs observations et suggestions pour améliorer les prochaines publications.",
  link: "/documents/NewsStats/NEWSSTAT_SEPTEMBRE_2025.pdf",
  date: "2025-09-30",
  image: 'assets/Bulletins/newsStat.PNG',
},

   {
    title: "NewsStat du deuxième trimestre 2025",
    description: "La NewsStat T2-2025 met en avant la validation des profils socio-économiques des 18 provinces et du cadre méthodologique des statistiques de l’état civil au Burundi.",
    link: "/documents/NewsStats/NEWSSTAT_JUIN_2025.pdf",
    date: "2025-09-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },
   {
    title: "NewsStat du premier trimestre 2025",
    description: "Le NewsStat du 1ᵉ trimestre 2025 met en lumière les avancées institutionnelles et statistiques majeures, dont la publication des résultats préliminaires du RGPHAE 2024, des ateliers de renforcement des capacités, l’analyse de l’inflation, ainsi que la participation active aux instances nationales et internationales.",
    link: "/documents/NewsStats/NEWSSTAT_MARS_FIN.pdf",
    date: "2025-03-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },

   {
    title: "NewsStat du troisieme trimestre 2024",
    description: "Le NewsStat du troisième trimestre 2024 met en lumière les principales initiatives et réalisations de l'Institut de Statistiques du Burundi. Ce numéro couvre des événements stratégiques tels que l’Atelier national sur le Système de Comptabilité Économique et Environnementale (SCEE), ainsi que les ateliers régionaux dédiés à la dissémination des indicateurs de suivi de la Vision Burundi 2040-2060, du PND révisé et des Objectifs de Développement Durable (ODD). Il propose également une analyse de l’inflation moyenne annuelle et revient sur les temps forts du 13ème Mois de la Statistique au Burundi (MSB) et de la Journée Africaine de la Statistique (JAS). Enfin, il souligne le lancement officiel du projet de financement additionnel pour le programme régional de statistiques de la Communauté Est-Africaine, marquant un engagement renforcé en faveur du développement des capacités statistiques.",
    link: "/documents/NewsStats/NEWSSTAT_DECEMBRE_FIN.pdf",
    date: "2024-12-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "NewsStat du deuxième trimestre 2024",
    description: "La présentation des actions pour promouvoir la culture statistique, incluant la 31ème Journée Africaine de la Statistique et des ateliers de renforcement des capacités.",
    link: "/documents/NewsStats/NewsStat_Trimestre-2_VF_Fevrier_2024.pdf",
    date: "2023-12-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "NewsStat du premier trimestre 2024",
    description: "La mise en avant des activités d'appui technique, réunions et ateliers, ainsi que les indices des prix à la consommation des ménages et du commerce extérieur.",
    link: "/documents/NewsStats/NEWSSTAT-BOUCLE_VF_13.11.2023_A-Imprimer-1-1.pdf",
    date: "2023-11-01",
     image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "NewsStat du deuxième trimestre 2023-2024",
    description: "La Direction Générale de l’Institut National de la Statistique du Burundi présente la NewsStat pour le deuxième trimestre 2023-2024 (octobre à décembre 2023).",
    link: "/documents/NewsStats/NewsStat_Trimestre-2_VF_Fevrier_2024.pdf",
    date: "2023-12-01",
    image: 'assets/Bulletins/newstat1_2017.PNG',
  },
  {
    title: "NewsStat du premier trimestre 2023-2024",
    description: "La Direction Générale de l’Institut National de la Statistique du Burundi annonce la publication de la NewsStat pour le premier trimestre 2023-2024.",
    link: "/documents/NewsStats/NEWSSTAT-BOUCLE_VF_13.11.2023_A-Imprimer-1-1.pdf",
    date: "2023-11-01",
    image: 'assets/Bulletins/newstat1_2017.PNG',
  },
  {
    title: "NewsStat du deuxième trimestre de l’année 2017",
    description: "L'Institut de Statistiques et d'Études Economiques du Burundi (ISTEEBU) présente son deuxième bulletin d'information statistique, « La NewsStat Burundi ». Ce bulletin se concentre sur les réalisations statistiques du 2ème trimestre 2017.",
    link: "/documents/NewsStats/NEWSSTAT-B-N.2-B1-Vrai-au-16.08.2017.pdf", 
    date: "2017-08-01",
    image: 'assets/Bulletins/newstat1_2017.PNG',
  },
  {
    title: "NewsStat du premier trimestre de l’année 2017",
    description: "L’Institut de Statistiques et d’Etudes Economiques du Burundi (ISTEEBU) lance son premier bulletin d’information, « La NewsStat Burundi ».",
    link: "/documents/NewsStats/NewsStat-Burundi-N0-1-avril.pdf", 
    date: "2017-04-01",
    image: 'assets/Bulletins/newstat1_2017.PNG',
  }
];

function NewsStat() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsStatistiquesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredBulletins(bulletinsStatistiquesData);
    } else {
      const filtered = bulletinsStatistiquesData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#673AB7',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54'
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: '#6B778C',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '500',
            padding: '10px 20px',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.15)',
            },
            borderRadius: '8px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: {
            fontWeight: '500',
            fontSize: '1rem'
          },
          h4: {
            fontWeight: '600',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginBottom: '16px',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            NewsStat
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Bienvenue sur la page NewsStat, votre source essentielle pour accéder aux dernières actualités et analyses statistiques concernant le Burundi.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de publication"
            >
              <MenuItem value="Tous">Tous les  NewsStats </MenuItem>
              {[...new Set(bulletinsStatistiquesData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>


          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 151, height: 200, m: 2 }}
                      image={bulletin.image}
                      alt={bulletin.title}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={bulletin.link}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de NewsStat
            </Button>
          )}
           <br />
           <br />
          <Typography
  variant="body1"
  align="justify"
  paragraph
  
  style={{ marginBottom: '24px', lineHeight: 1.6 }}
>
  <strong>Note :</strong> Les <strong>NewsStats de l'INSBU</strong> représentent une source essentielle d'information statistique pour le Burundi. Ces bulletins sont publiés trimestriellement, généralement <strong>45 jours</strong> après la clôture de chaque trimestre, permettant ainsi d'assurer une diffusion rapide et efficace des données pertinentes.
  
  <strong>Calendrier de publication :</strong> Les dates prévues pour la publication de ces NewsStats sont les suivantes :
  <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
    <li><strong>15 février</strong> - Publication des données pour le quatrième trimestre de l'année précédente.</li>
    <li><strong>15 mai</strong> - Publication des données pour le premier trimestre de l'année en cours.</li>
    <li><strong>15 août</strong> - Publication des données pour le deuxième trimestre de l'année en cours.</li>
    <li><strong>15 novembre</strong> - Publication des données pour le troisième trimestre de l'année en cours.</li>
  </ul>

 
</Typography>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default NewsStat;